<template>
  <div class="Healthbox">
    <div class="Healthtitlebox" :style="{color:progressbar_data.color}">
      <div class="title">{{ progressbar_data.title }}
        <span v-if="!progressbar_data.percentage">{{ width }}</span>
      </div>
      <div class="data" v-if="progressbar_data.cshow==1">{{ progressbar_data.max }}{{ progressbar_data.unit }}</div>
      <div class="data" v-else>{{ progressbar_data.value }}/{{ progressbar_data.max }}{{ progressbar_data.unit }}</div>
    </div>
    <div class="Healthjdtbox" :style="{background:progressbar_data.bgcolor}">
      <div class="jdt" :style="{background:progressbar_data.color,width:width}"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "jdt",
  watch: {
    progressbar_data: {
      handler() {
        // console.log('监听到progressbar_data变化')
        this.getshow()
      },
      // 深度监听
      deep: true,
      // 首次绑定
      immediate: true
    }
  },
  props: ["progressbar_data"],
  data() {
    return {
      width: '0%'
      // {title:'健康',//标题内容
      //  color:'#17C720',//主颜色
      //  bgcolor:'#B9FBBC',//背景条默认颜色
      //  value:1,//当前值
      //  max:5,//上限
      //  unit:'仓',//单位
      //  settime:0//定时器的时长
      //   }
    };
  },
  methods: {
    getshow() {
      setTimeout(() => {
        if (this.progressbar_data.max == 0) {
          this.width = 0
        } else {
          this.width = (this.progressbar_data.value * 100 / this.progressbar_data.max).toFixed(2) + '%';
        }
      }, this.progressbar_data.settime);
    }
  }
};
</script>
<style lang="scss" scoped>
.Healthbox {
  width: 100%;

  .Healthtitlebox {
    display: flex;
    justify-content: space-between;
    font-family: Adobe Heiti Std;
    margin-bottom: 6px;

    .title {
      font-weight: normal;
      font-size: 16px;
    }

    .data {
      font-weight: bold;
      font-size: 24px;
    }
  }

  .Healthjdtbox {
    width: 100%;
    height: 14px;

    .jdt {
      transition: all 1.4s;
      height: 100%;
    }
  }
}
</style>
